// extracted by mini-css-extract-plugin
export var bold = "_rk-0";